import styled, { css } from 'styled-components/macro';
import Icon from './Icon';

export const CheckboxContainer = styled.div`
  margin: 20px 0;
  display: flex;
  input {
    visibility: hidden;
    position: absolute;
  }
`;

export const CheckboxDiv = styled.div`
  border: ${props => props.theme.defaultBorder};
  height: 1.5rem;
  min-width: 1.5rem;
  max-width: 1.5rem;
  cursor: arrow;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  &:hover {
    border-color: ${props => props.theme.blue};
  }
  ${props =>
    (props.readOnly || props.disabled) &&
    css`
      &:hover {
        border-color: ${props => props.theme.mercury};
      }
    `}
  ${props =>
    props.disabled &&
    css`
      background-color: ${props => props.theme.concrete};
    `}
`;

export const CheckboxLabel = styled.label`
  margin-left: 1.2rem;
  line-height: 1.6rem;
`;

export const CheckmarkIcon = styled(Icon)`
  height: 0.7rem;
  fill: ${props => props.theme.blue};
`;

export const ValidationSmall = styled.small`
  display: block;
  text-align: ${props => props.validationTextAlign};
  color: ${props => props.theme.red};
  margin: -15px 0 20px;
  /* margin-left: 10px; */
`;
